import styled from 'styled-components';
import { breakpoints } from '@bnnvara/breakpoints';
export const FollowBrandButton = styled.div`
  background-color: transparent;
  color: ${props => props.color};
  border-color: ${props => props.color};

  svg {
    fill: ${props => props.color};
    margin-left: 2px;
    width: 14px !important;
  }

  &:hover {
    color: ${({
  theme
}) => theme.base.black};
    background: ${({
  theme
}) => theme.base.white};
    svg {
      fill: ${({
  theme
}) => theme.base.black};
    }
    path {
      fill: ${({
  theme
}) => theme.base.black};
      stroke: ${({
  theme
}) => theme.base.black};
    }
  }

  &:active {
    color: ${({
  theme
}) => theme.secondary.dark};
    border-color: ${({
  theme
}) => theme.secondary.dark};
    path {
      fill: ${({
  theme
}) => theme.secondary.dark};
      stroke: ${({
  theme
}) => theme.secondary.dark};
    }
  }

  &:disabled {
    cursor: default;
  }
`;
export const TextFollow = styled.span`
  ${breakpoints.md} {
    margin-left: 2px;
  }
`;
export const SvgContainer = styled.span`
  width: 24px;
  height: 20px;
  margin-top: 4px;
  line-height: 18px;
  fill: 'black';
`;
export const LoadingContainer = styled.span`
  display: inline-block;
  margin: 0;
`;